import React, { useMemo } from "react";
import { Col, Typography } from "antd";
import { usePostHog } from "@posthog/react";
import CollectionFileIcon from "../../../assets/icons/collection-file.svg";
import CollectionPriceIcon from "../../../assets/icons/collection-price.svg";
import { ICollections } from "../../../helpers/types";
import { generateImageAltText } from "../../../utls/imageAltGenerator";

interface Props {
  collection: ICollections;
  handleNavigation: (id: string) => void;
  profileName?: string;
  username?: string;
  index?: number;
}

const CollectionItem: React.FC<Props> = ({ collection, handleNavigation, profileName, username, index }) => {
  const posthog = usePostHog();
  const altText = useMemo(
    () =>
      generateImageAltText({
        name: profileName,
        username: username,
        index: index,
        id: collection._id,
        fallback: "collection",
      }),
    [profileName, username, index, collection._id]
  );

  return (
    <Col
      className="collection-item"
      span={8}
      onClick={() => {
        posthog.capture('collection_clicked', {
          collection_id: collection._id,
          collection_title: collection.title,
          price: collection.price,
          files_count: collection.filesCount,
          creator_username: username,
          creator_name: profileName
        });
        handleNavigation(collection._id);
      }}
    >
      <div className="collection-box">
        <img className="collection-img" src={collection.thumbnail} alt={altText} title={altText} />
        <div className={`${collection.price === undefined ? "d-none" : ""} overlay-left`}>
          <img src={CollectionPriceIcon} className="overlay-icon" alt="price" />
          <span className="overlay-text">{collection.price} €</span>
        </div>
        <div className="overlay-right">
          <img src={CollectionFileIcon} className="overlay-icon" alt="files" />
          <span className="overlay-text">{collection.filesCount}</span>
        </div>
        <div className="overlay-bottom">
          <div className="collection-description-container">
            <Typography.Text className="collection-description-text">{collection.title}</Typography.Text>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default CollectionItem;
